import GroupLayout from "./GroupLayout";
import { packageGroupRoutes } from "./modules/package-group/routes";

export const groupRoutes = {
  path: "group",
  component: GroupLayout,
  children: [
    ...packageGroupRoutes()
  ]
};



// WEBPACK FOOTER //
// ./src/features/group/routes.js